export default __webpack_public_path__ + "static/2_17-484d8b2914fb467534d2768469706f45.png";